import { CART_PRODUCT_TYPES } from "../constants/index.js";
import { getRulesLineItem, getProductLineItem, getTotalLineItem, getExtraLineItem, getTotalBreakDownLineItem, getSalePaymentLineItem, reArangeCarts } from "../utils/sale-products-breakdown.utils/index.js";
export default function cartsBreakdownFactory(_ref) {
  var saleStore = _ref.saleStore;
  var payments = saleStore.payments,
    hasMultiCart = saleStore.hasMultiCart,
    carts = saleStore.carts,
    cartsObject = saleStore.cartsObject;
  var reArrangeSaleCart = reArangeCarts(carts);
  var saleCartsBreakDown = reArrangeSaleCart.map(function (cart) {
    var _cartDetail$products, _cartDetail$products2;
    var cartDetail = cartsObject.find(function (cartObject) {
      return cartObject.cartId === cart.cartId;
    });
    var _cartDetail$displayIt = cartDetail.displayItems,
      lineItems = _cartDetail$displayIt.lineItems,
      includeTotalWithVat = _cartDetail$displayIt.includeTotalWithVat,
      total = _cartDetail$displayIt.total;
    var keyToReadPrice = includeTotalWithVat ? 'totalWithVat' : 'subTotal';
    var product = cartDetail === null || cartDetail === void 0 ? void 0 : (_cartDetail$products = cartDetail.products) === null || _cartDetail$products === void 0 ? void 0 : _cartDetail$products.find(function (p) {
      return (p === null || p === void 0 ? void 0 : p.type) === cart.type;
    });
    var productLineItem = getProductLineItem(lineItems, total, keyToReadPrice, product, includeTotalWithVat);
    var rulesLineItem = getRulesLineItem(lineItems.filter(function (l) {
      return l.type === CART_PRODUCT_TYPES.RULE;
    }), total, keyToReadPrice);
    var extraLineItem = getExtraLineItem(cartDetail === null || cartDetail === void 0 ? void 0 : (_cartDetail$products2 = cartDetail.products) === null || _cartDetail$products2 === void 0 ? void 0 : _cartDetail$products2.find(function (p) {
      return (p === null || p === void 0 ? void 0 : p.type) === cart.type;
    }), cart.type);
    var salePaymentLineItem = getSalePaymentLineItem(payments, keyToReadPrice, total.currency, total, hasMultiCart);
    var totalBreakdownLineItem = getTotalBreakDownLineItem(total);
    var totalLineItem = getTotalLineItem(total, false, hasMultiCart, saleStore.saleDisplaytotal);
    return {
      id: cart.cartId,
      type: cart.type,
      includeTotalWithVat: includeTotalWithVat,
      productLineItem: productLineItem,
      rulesLineItem: rulesLineItem,
      totalBreakdownLineItem: totalBreakdownLineItem,
      totalLineItem: totalLineItem,
      salePaymentLineItem: salePaymentLineItem,
      extraLineItem: extraLineItem
    };
  });
  return saleCartsBreakDown;
}